import { Package } from '../../models/Package'
import { WorkflowPage } from '../workflows/WorkflowPage'

type Props = {
    packageObj: Package
}

export const NewPackageCompletePage = ({ packageObj }: Props) => {
    const { onReset } = WorkflowPage.useResetContainerContext()

    return (
        <div className="flex items-center justify-center">
            <div className="max-w-xlarge mt-12">
                <WorkflowPage.SuccessView
                    subtitle="The package with your client was saved"
                    links={[
                        {
                            id: 'create-another',
                            onClick: onReset,
                            title: 'Create another',
                            subtitle: 'Sell another package',
                            icon: 'plus.large',
                        },
                        {
                            id: 'view',
                            to: `/packages/${packageObj.id}`,
                            title: 'View package',
                            subtitle: 'View this package',
                            icon: 'package2.large',
                        },
                        {
                            id: 'dashboard',
                            to: '/',
                            title: 'Dashboard',
                            subtitle: 'View home screen',
                            icon: 'home.large',
                        },
                    ]}
                />
            </div>
        </div>
    )
}
